import React from 'react';
import { tokens as t, fonts as font } from '../../tokens';

export function TopNav({ children, logo, actions }) {
  return (
    <nav style={{
      background: t.navBg,
      display: "flex", alignItems: "center",
      padding: "0 20px", height: 56,
      fontFamily: font.body,
      boxShadow: "0 2px 12px rgba(26,39,54,0.15)",
    }}>
      {logo && <div style={{ marginRight: 36, flexShrink: 0 }}>{logo}</div>}
      <div style={{ display: "flex", flex: 1 }}>{children}</div>
      {actions && <div style={{ display: "flex", gap: 7, alignItems: "center" }}>{actions}</div>}
    </nav>
  );
}

export function NavItem({ children, active, onClick }) {
  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={onClick}
        style={{
          background: "none", border: "none", cursor: "pointer",
          color: active ? "#fff" : t.textNav,
          fontWeight: active ? 700 : 400,
          fontSize: 13.5, padding: "0 15px", height: 56,
          fontFamily: font.body, transition: "color 0.15s",
        }}
      >{children}</button>
      {active && (
        <div style={{ position: "absolute", bottom: 0, left: "50%", transform: "translateX(-50%)", width: 0, height: 0, borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderBottom: `6px solid ${t.pageBg}` }} />
      )}
    </div>
  );
}

export function SubNav({ tabs, active, onChange, actions }) {
  return (
    <div style={{
      background: t.surface,
      borderBottom: `1.5px solid ${t.border}`,
      display: "flex", alignItems: "center",
      padding: "0 22px", fontFamily: font.body,
    }}>
      <div style={{ display: "flex", flex: 1 }}>
        {tabs.map(tab => {
          const isActive = tab === active;
          return (
            <button key={tab} className="rf-tab" onClick={() => onChange && onChange(tab)} style={{
              background: "none", border: "none", cursor: "pointer",
              padding: "13px 18px", fontSize: 13,
              fontWeight: isActive ? 700 : 400,
              color: isActive ? t.textPrimary : t.textSecondary,
              borderBottom: `2.5px solid ${isActive ? t.emerald : "transparent"}`,
              transition: "all 0.15s", fontFamily: font.body,
            }}>{tab}</button>
          );
        })}
      </div>
      {actions && <div style={{ display: "flex", gap: 8, alignItems: "center" }}>{actions}</div>}
    </div>
  );
}

export function Sidebar({ sections, activeItem, onItemClick }) {
  return (
    <div style={{ width: 215, background: t.surface, borderRight: `1.5px solid ${t.border}`, padding: "14px 0", fontFamily: font.body, flexShrink: 0 }}>
      {sections.map((sec, si) => (
        <div key={si} style={{ marginBottom: 6 }}>
          {sec.title && (
            <div style={{ fontSize: 9.5, fontWeight: 800, letterSpacing: "0.1em", color: t.textMuted, textTransform: "uppercase", padding: "8px 16px 4px" }}>{sec.title}</div>
          )}
          {sec.items.map(item => {
            const isActive = item.label === activeItem;
            return (
              <button key={item.label} className="rf-sitem" onClick={() => onItemClick && onItemClick(item.label)} style={{
                width: "100%",
                background: isActive ? t.emeraldLight : "none",
                border: "none",
                borderLeft: `3px solid ${isActive ? t.emerald : "transparent"}`,
                cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "9px 14px",
                color: isActive ? t.emeraldDeep : t.textSecondary,
                fontWeight: isActive ? 700 : 400, fontSize: 13.5, fontFamily: font.body,
                transition: "all 0.12s",
              }}>
                <span style={{ display: "flex", alignItems: "center", gap: 9 }}>
                  {item.icon && <span style={{ fontSize: 13 }}>{item.icon}</span>}
                  {item.label}
                </span>
                {item.count !== undefined && (
                  <span style={{
                    background: isActive ? `${t.emerald}22` : "#f3f4f6",
                    color: isActive ? t.emeraldDeep : t.textMuted,
                    borderRadius: 99, fontSize: 10.5, fontWeight: 700,
                    padding: "1px 7px", fontFamily: font.mono,
                  }}>{item.count}</span>
                )}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
